module.exports = __webpack_public_path__ + "static/media/RichTwo.8503bb7c.png";